module.exports = __webpack_public_path__ + "static/media/elo.c2a3b7f6.svg";